module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (196).72b75eb5.jpg";